import { render, staticRenderFns } from "./modify-user.vue?vue&type=template&id=6ad52bbd&scoped=true&"
import script from "./modify-user.vue?vue&type=script&lang=js&"
export * from "./modify-user.vue?vue&type=script&lang=js&"
import style0 from "./modify-user.vue?vue&type=style&index=0&id=6ad52bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad52bbd",
  null
  
)

export default component.exports